// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"60431757","181":"cd1f8f04","245":"a3ad5bc2","307":"d750dae1","455":"b81426ef","635":"02b8241e","682":"f3751ea3","715":"96b7297f","741":"02fa1de7","765":"c91106ed","772":"dacc8a52","868":"2d1f9200"}[chunkId] + ".chunk.js";
};